
import React, { useState } from 'react';
import { getStudioApiKey } from '../utils/audio';

interface SyncCenterProps {
  ui: any;
}

const SyncCenter: React.FC<SyncCenterProps> = ({ ui }) => {
  const t = ui.sync;
  const [syncStatus, setSyncStatus] = useState<string | null>(null);
  const hasKey = !!getStudioApiKey();

  return (
    <div className="h-full max-w-4xl mx-auto space-y-16 animate-in fade-in slide-in-from-bottom-6 duration-700 pb-20 text-left">
      <div className="text-center space-y-6">
        <h2 className="text-6xl font-black text-white tracking-tighter uppercase">{t.title}</h2>
        <p className="text-xl text-gray-400 font-light max-w-2xl mx-auto leading-relaxed">{t.subtitle}</p>
        
        <div className="flex justify-center pt-4">
           <div className={`px-10 py-3 rounded-full text-[9px] font-black uppercase tracking-[0.4em] border flex items-center gap-4 ${hasKey ? 'bg-green-500/10 text-green-500 border-green-500/20' : 'bg-red-500/10 text-red-500 border-red-500/20'}`}>
              <i className={`fa-solid ${hasKey ? 'fa-check-circle' : 'fa-triangle-exclamation'}`}></i>
              Handshake: {hasKey ? 'Securely Linked' : 'Awaiting Vault Key'}
           </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
         <div className="p-12 rounded-[3.5rem] bg-black/40 border border-white/5 backdrop-blur-3xl space-y-8 flex flex-col justify-between">
            <div className="space-y-6">
                <h3 className="text-3xl font-black text-white uppercase tracking-tighter">{t.export_title}</h3>
                <p className="text-gray-400 font-light leading-relaxed">{t.export_body}</p>
            </div>
            <button className="w-full py-6 bg-white text-black font-black rounded-3xl uppercase tracking-widest text-xs hover:bg-groove-accent transition-all shadow-xl">
                {t.button_export}
            </button>
         </div>

         <div className="p-12 rounded-[3.5rem] bg-black/40 border border-white/5 backdrop-blur-3xl space-y-8 flex flex-col justify-between">
            <div className="space-y-6">
                <h3 className="text-3xl font-black text-white uppercase tracking-tighter">{t.import_title}</h3>
                <p className="text-gray-400 font-light leading-relaxed">{t.import_body}</p>
            </div>
            <label className="w-full py-6 bg-white/5 border border-white/10 text-white font-black rounded-3xl uppercase tracking-widest text-xs hover:bg-white/10 transition-all cursor-pointer text-center block">
                {t.button_import}
                <input type="file" className="hidden" />
            </label>
         </div>
      </div>
    </div>
  );
};

export default SyncCenter;
